<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>ITEM</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            id="codigo"
            v-model="form.codigo"
            :tooltip="form.codigo"
          >
            <span>Código*</span>
            <span v-if="errores.codigo" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.codigo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="form-field">
          <input-field
            id="nombre"
            v-model="form.descripcion"
            :tooltip="form.descripcion"
          >
            <span>Nombre*</span>
            <span v-if="errores.descripcion" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>      
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            id="codigo_barra"
            v-model="form.codigo_barra"
            :tooltip="form.codigo_barra"
          >
            <span>Cód. Barra</span>
            <span v-if="errores.codigo_barra" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.codigo_barra[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Foto</label>
            <button 
              class="btn-warning" 
              @click="eliminarArchivo()" 
              type="button" 
              v-show="form.url_foto != null || form.archivo != null"
            >
              <i class="fa fa-trash"></i>
            </button>
            <button 
              class="btn-info" 
              @click="descargarArchivo()" 
              type="button" 
              v-show="form.url_foto != null && form.archivo == null"
            >
              <i class="fa fa-download"></i>
            </button>  
            <fileUpload
              :id="'archivo'"
              ref="archivo"
              :extensiones="'.JPEG,.gif,.jpg,.png,.PNG,.JPG'"  
              :pathDefault="'/images/no-logo.png'"
              :defaultImage="form.url_foto != null ? form.url_foto : '/images/no-logo.png'"
              @imagenCargada="setearArchivo()"
              :tamanoMaximo="5000000"
              :descripcionMaximo="'5mb'"
              cargarImagenDefecto     
              verMiniatura      
            >
            </fileUpload>
          </div>
        </div> 
      </div>      
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            id="precio"
            v-model="form.precio"
            placeholder="$ #,###.##"
          >
            <span>Precio 1</span>
            <span v-if="errores.precio" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.precio[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            id="precio2"
            v-model="form.precio2"
            placeholder="$ #,###.##"
          >
            Precio 2
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            id="precio3"
            v-model="form.precio3"
            placeholder="$ #,###.##"
          >
            Precio 3
          </input-field>
        </div>
      </div>   
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field
            vMoney
            :format="money"
            id="costo"
            v-model="form.costo"
          >
            <span>Costo</span>
            <span v-if="errores.costo" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.costo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>   
    </div>    
    <div class="modal-buttons">
      <button type="button" @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
      <button type="button" @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    descripcionItem: {
      type: String,
      required: false,
      default: "",
    },
    itemId: {
      type: String,
      required: false,
      default: "",
    },
    urlFoto: {
      required: false,
    },
    value: {
      type: Object,
      required: false,
      default: function () {
        return {};
      },
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      imageDefault:
        this.urlFoto != null ? this.urlFoto : url + "/images/sin-imagen.jpg",
      money: money,
      errores: {}
    };
  },
  methods: {
    eliminarArchivo: function() {
      let that = this;
      swal({
        title: "¿Desea eliminar la foto?",
        text: "",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then(result => {
        if(result.value) {
          that.form.archivo = null;
          that.form.foto = null;
          that.form.url_foto = null;
          that.$refs.archivo.setDefaultImage();   
          that.$forceUpdate();
        }
      });
    },
    descargarArchivo: function() {
      let that = this;
      swal.fire({
        title: "¿Desea descargar la foto?",
        text: "",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then(result => {
        if(result.value) {
          let urlApi = url + '/inventario/item/descargar-archivo/' + that.form.id;
          window.open(urlApi, "_blank");
        }      
      }); 
    },
    setearArchivo: function() {
      this.form.archivo = this.$refs.archivo.recuperarImagen();
    },
    guardar: function() {
      if(this.form.id != null)
        this.actualizar();
      else
        this.guardarNuevo();
    },
    guardarNuevo: function() {
      let that = this;
      swal({
        title: "¿Desea guardar el ítem?",
        text: "Se requiere confirmación",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          that.errores = {};
          let urlApi = `${url}/inventario/item/guardar`;
          axios
            .post(urlApi, that.form)
            .then((response) => {
              swal(
                "El item fue registrado exitósamente.",
                "Aviso",
                "success"
              );
              this.$emit("preciosActualizados");
              this.$emit("cerrar");
            })
            .catch((error) => {
              let response = error.response;
              if(response != null) {
                let status = response.status;
                if(status === 422) {
                  that.errores = response.data.errors;
                  swal.fire('Error', 'Hay datos por corregir en el formulario', 'error');
                  return;
                }
              }
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    actualizar: function () {
      let that = this;
      swal({
        title: "¿Desea actualizar el ítem?",
        text: "Se requiere confirmación",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          that.errores = {};
          axios
            .post(url + "/inventario/items/" + this.itemId, {
              codigo: this.form.codigo,
              descripcion: this.form.descripcion,
              codigo_barra: this.form.codigo_barra,
              costo: this.form.costo,
              precio: this.form.precio,
              precio2: this.form.precio2,
              precio3: this.form.precio3,
              archivo: this.form.archivo,
              foto: this.form.foto,
              _method: "PUT",
            })
            .then(() => {
              swal(
                "El item fue actualizado exitósamente.",
                "Aviso",
                "success"
              );
              this.$emit("preciosActualizados");
              this.$emit("cerrar");
            })
            .catch((error) => {
              let response = error.response;
              if(response != null) {
                let status = response.status;
                if(status === 422) {
                  that.errores = response.data.errors;
                  swal.fire('Error', 'Hay datos por corregir en el formulario', 'error');
                  return;
                }
              }
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cerrar: function () {
      let that = this;
      swal.fire({
        title: '¿Desea cancelar la operación de guardado de item?',
        text: "",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar"
      }).then(result => {
        if(result.value) {
          this.$emit('cerrar');
        }
      });
    },
    subir: function () {
      let input = document.querySelector("#foto");
      let file = input.files[0];
      if (!file || !file.type.match(/image.*/)) {
        swal("Debe seleccionar una imagen.", "Aviso", "warning");
      } else {
        let fd = new FormData();
        fd.append("foto", file);
        fd.append("item_id", this.itemId);
        axios({
          method: "post",
          url: url + "/inventario/item/foto",
          data: fd,
          headers: { "Content-Type": "multipart/form-data" },
        })
          .then(() => {
            swal("La imagen fue subida exitósamente.", "Realizado", "success");
            this.$emit("uploaded");
          })
          .catch(({ response }) => {
            if (response.status == 422) {
              swal(response.data.errors.foto[0]), "Aviso", "warning";
            } else swal("Hubo un error, intente nuevamente.", "Error", "error");
          });
      }
    },
  },  
  mounted: function () {
    /*document.getElementById("foto").onchange = function (event) {
      let selectedFile = event.target.files[0];
      let reader = new FileReader();

      let imgtag = document.getElementById("imagen");
      imgtag.title = selectedFile.name;

      reader.onload = function (event) {
        imgtag.src = event.target.result;
      };
      reader.readAsDataURL(selectedFile);
    };*/
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/inventario/EdicionItem.vue